// Spanish admin UI translations.
const es = {
  " · 만료됨": " · Caducado",
  "% · 하위에이전트": "% · Subagentes",
  "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) desea asignar al subagente?",
  "(password 있음)": "(contraseña configurada)",
  "(링크 없음)": "(sin enlace)",
  "(본문 없음)": "(sin contenido)",
  "(본인/직속 하위 에이전트의": "(Muestra valores acumulados por color para usted/subagentes directos",
  "(없음)": "(ninguno)",
  "(여기 클릭하면 새 공지 모달 오픈)": "(Haga clic aquí para abrir el modal de nuevo aviso)",
  "(이름없음)": "(sin nombre)",
  "(자동)": "(automático)",
  "(제목 없음)": "(sin título)",
  "* index를 바꾼 뒤": "* Después de cambiar el índice,",
  "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* En modo infinito, se muestra en la interfaz como «se renueva cada 30 días»",
  "* 예: 상위 50% 중": "* Ejemplo: del 50% del superior,",
  "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* Esta configuración controla la cuenta regresiva dentro de la tarjeta informativa. La configuración de tiempo anterior solo controla el período de exposición en el lobby.",
  "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* Este estilo solo se aplica a los elementos de texto de la tarjeta informativa. Los temporizadores/iconos mantienen su estilo actual.",
  "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* A continuación solo se muestran los grupos válidos en este momento (display_sets.time).",
  "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* Se guarda en UTC; en pantalla se introduce/muestra en hora local.",
  "* 필요할 때만 추가하면 됨": "* Añádalo solo cuando sea necesario.",
  "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* No hay ningún DisplaySet con un período de rango alrededor de la hora de referencia actual (±15–45 días).",
  "+ 공지 작성": "+ Crear aviso",
  "+ 광고 등록": "+ Añadir anuncio",
  "+ 새 공지 작성": "+ Nuevo aviso",
  "+ 새 광고 등록": "+ Nuevo anuncio",
  "+ 아이콘(업로드)": "+ Icono (subir)",
  "+ 이미지": "+ Imagen",
  "+ 인포 버튼 추가": "+ Añadir botón de información",
  "+ 인포카드 추가": "+ Añadir tarjeta informativa",
  "+ 타이머(표시여부)": "+ Temporizador (visibilidad)",
  "+ 텍스트": "+ Texto",
  "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING solo se guarda y no se muestra.",
  "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED se muestra automáticamente después de startAt.",
  "- endAt 이 지나면 자동 만료": "- Caduca automáticamente después de endAt.",
  "/community/notice/1 또는 https://...": "/community/notice/1 o https://...",
  "/notice/123 또는 https://...": "/notice/123 o https://...",
  "0 이상 숫자를 입력하세요.": "Introduzca un número mayor o igual que 0.",
  "0보다 큰 금액을 입력하세요.": "Introduzca un importe mayor que 0.",
  "0보다 큰 숫자만 가능": "Solo se permiten números mayores que 0.",
  "24시간 반복": "Repetir cada 24 horas",
  "2차 비밀번호(선택)": "Contraseña secundaria (opcional)",
  "Country 필터": "Filtro de país",
  "DB/API 기반 에이전트 유료 업로드 관리": "Gestión de cargas pagadas de agentes basada en DB/API",
  "Device 필터": "Filtro de dispositivo",
  "DisplaySet 날짜 필터(1일 단위)": "Filtro de fecha de DisplaySet (unidad de 1 día)",
  "Due Date 지정": "Establecer fecha límite",
  "Due Date(관리자 로컬 시간)": "Fecha límite (hora local del administrador)",
  "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "Introduzca una fecha/hora límite válida.",
  "Due Date를 입력해야 합니다.": "La fecha límite es obligatoria.",
  "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "Solo se guardan bloques de texto/imagen sin almacenar HTML.",
  "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "Crear RUN: introduzca la apuesta total de la misión (target_total_bet)",
  "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "Crear RUN: introduzca la apuesta total de la misión de mesa (target_total_bet)",
  "Rake % (수수료율)": "Rake % (tasa de comisión)",
  "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB deben ser números mayores que 0, con hasta 2 decimales. Ejemplo: 0.25 / 0.50",
  "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share debe ser un número entre 0 y 1 (p. ej., 0.2).",
  "endAt (종료, 선택)": "endAt (fin, opcional)",
  "endAt은 startAt보다 늦어야 해.": "endAt debe ser posterior a startAt.",
  "fee_percent (선택, %)": "fee_percent (opcional, %)",
  "fee_percent(유저)": "fee_percent (usuario)",
  "index(선택)": "index (opcional)",
  "message는 빈값이 될 수 없습니다.": "El mensaje no puede estar vacío.",
  "message는 필수입니다.": "El mensaje es obligatorio.",
  "onCredit 콜백이 연결되어 있지 않습니다.": "La devolución de llamada onCredit no está conectada.",
  "onDebit 콜백이 연결되어 있지 않습니다.": "La devolución de llamada onDebit no está conectada.",
  "reserve_time_utc(표시:로컬)": "reserve_time_utc (visualización: local)",
  "reserve_time_utc가 지난 waiting들을 running으로 전환": "Mover a running los elementos waiting cuyo reserve_time_utc ya pasó.",
  "startAt (시작)": "startAt (inicio)",
  "status(선택)": "status (opcional)",
  "superadmin 전용 UI (admin-server / DB 저장)": "Interfaz solo para superadmin (admin-server / almacenamiento en DB)",
  "tick 실패": "Error de tick",
  "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· El servidor vuelve a validar categoría/estado/coste/permisos.",
  "· 소속유저": "· Usuarios asignados",
  "※ 이미지는 admin server 의": "※ Las imágenes se almacenan en el admin server ",
  "※ 입력이 없으면 0%로 처리됩니다.": "※ Si está vacío, se trata como 0%.",
  "※ 입력이 없으면 0.00%로 처리됩니다.": "※ Si está vacío, se trata como 0.00%.",
  "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ Los guardados actuales se reflejan en la DB mediante la API de admin-server.",
  "→ 하위는": "→ El subagente recibe",
  "⚠️ 권한이 없습니다": "⚠️ No tiene permiso",
  "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "Aunque el área sea la misma, las combinaciones distintas de dispositivo/país se guardan como filas separadas.",
  "개": "elementos",
  "개 · 남은 수량": "elementos · Cantidad restante",
  "갱신 주기(일)": "Ciclo de renovación (días)",
  "갱신 중": "Actualizando",
  "건": "registros",
  "검색": "Buscar",
  "검색 (id / user_code / nickname / 메모)": "Buscar (id / user_code / nickname / nota)",
  "검색: 이름/링크/국가": "Buscar: nombre/enlace/país",
  "검색: 제목/본문/작성자": "Buscar: título/contenido/autor",
  "검색어를 입력하세요": "Introduzca un término de búsqueda",
  "게시": "Publicado",
  "게시 상태": "Estado de publicación",
  "게시 중": "Publicando",
  "게시일:": "Publicado el:",
  "결제 영역": "Área de pago",
  "결제 옵션": "Opciones de pago",
  "결제 옵션 추가": "Añadir opción de pago",
  "결제 완료": "Pago completado",
  "결제 항목": "Elemento de pago",
  "결제 항목 금액은 0보다 큰 정수여야 합니다.": "El importe del elemento de pago debe ser un entero mayor que 0.",
  "결제 항목 수량은 0 이상 정수여야 합니다.": "La cantidad del elemento de pago debe ser un entero mayor o igual que 0.",
  "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "La cantidad del elemento de pago no puede establecerse por debajo de la cantidad ya vendida.",
  "결제 항목명을 입력하세요.": "Introduzca el nombre del elemento de pago.",
  "결제관리": "Gestión de pagos",
  "경로": "Ruta",
  "계정의 정보를 수정합니다.": "Editar la información de la cuenta.",
  "공지 관리": "Gestión de avisos",
  "공지 목록 불러오는 중...": "Cargando lista de avisos...",
  "공지 본문": "Contenido del aviso",
  "공지 수정": "Editar aviso",
  "공지 작성/관리": "Creación/gestión de avisos",
  "공지 제목": "Título del aviso",
  "공지가 없어. 위에서 새로 작성해줘.": "No hay avisos. Cree uno nuevo arriba.",
  "관리": "Gestionar",
  "관리 상태": "Estado de administración",
  "관리자 자산 표시 영역": "Área de resumen de activos del administrador",
  "광고 관리": "Gestión de anuncios",
  "광고 목록 불러오는 중...": "Cargando lista de anuncios...",
  "광고 목록을 불러오지 못했어.": "No se pudo cargar la lista de anuncios.",
  "광고 삭제에 실패했어.": "No se pudo eliminar el anuncio.",
  "광고 수정": "Editar anuncio",
  "광고 이미지": "Imagen del anuncio",
  "광고 이미지 등록/관리": "Registro/gestión de imágenes de anuncios",
  "광고 이미지를 업로드해줘.": "Suba una imagen del anuncio.",
  "광고 저장에 실패했어.": "No se pudo guardar el anuncio.",
  "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "Introduzca el país. Ejemplo: KR / US / JP / ALL",
  "굵기": "Grosor",
  "그룹 노출(DisplaySet)": "Exposición del grupo (DisplaySet)",
  "그룹 미션": "Misión de grupo",
  "그룹 미션 설정": "Configuración de misión de grupo",
  "그룹 미션 시작": "Iniciar misión de grupo",
  "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "No se pudo detener la misión de grupo (el backend necesita DELETE /admin/mission/run/:run_id)",
  "그룹 생성": "Crear grupo",
  "그룹 시간 설정이 올바르지 않습니다.": "La configuración de tiempo del grupo no es válida.",
  "그룹 이름": "Nombre del grupo",
  "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "El nombre del grupo, Small Blind y Big Blind son obligatorios. SB/BB pueden introducirse como 0.25, 0.50.",
  "그룹명": "Nombre del grupo",
  "글로벌": "Global",
  "금액": "Importe",
  "금액은 최소 50$ 이상 부터 가능합니다.": "El importe debe ser de al menos 50 $.",
  "기간": "Período",
  "나의 지갑 주소": "Mi dirección de wallet",
  "남미": "Sudamérica",
  "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "Historial de transferencias de activos de mi cuenta y de subcuentas directas/indirectas (agentes/usuarios). Puede buscar aplicando filtros.",
  "내 어카운트": "Mi cuenta",
  "내 자산 0,000,000": "Mi activo 0,000,000",
  "내부용 이름(label)": "Nombre interno (label)",
  "내부용 이름(label)을 입력해줘.": "Introduzca el nombre interno (label).",
  "내용(message)": "Contenido (message)",
  "노출": "Visible",
  "노출(즉시/기간무관)": "Visible (inmediato / sin límite de período)",
  "노출중": "Visible",
  "닉네임": "Apodo",
  "다음": "Siguiente",
  "닫기": "Cerrar",
  "데이터 없음": "Sin datos",
  "데이터가 없습니다.": "No hay datos disponibles.",
  "동남아": "Sudeste Asiático",
  "동아시아": "Asia Oriental",
  "등록": "Registrar",
  "등록된 결제 옵션이 없습니다.": "No hay opciones de pago registradas.",
  "등록된 광고가 없어.": "No hay anuncios registrados.",
  "등록된 라운지 글이 없습니다.": "No hay publicaciones de lounge registradas.",
  "등록된 이미지 없음": "Sin imagen registrada",
  "라운지 관리": "Gestión de lounge",
  "라운지 글": "Publicación de lounge",
  "라운지 글 목록": "Lista de publicaciones de lounge",
  "라운지 목록 불러오는 중...": "Cargando lista de lounge...",
  "라운지 목록을 불러오지 못했습니다.": "No se pudo cargar la lista de lounge.",
  "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "En los detalles del lounge se muestra como entrada de cantidad por elemento + botón de pago.",
  "라운지 아이템": "Elemento de lounge",
  "라운지 업로드": "Carga de lounge",
  "라운지 포인트 %": "Puntos de lounge %",
  "라운지 포인트 % (0~100)": "Puntos de lounge % (0–100)",
  "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "El porcentaje de puntos de lounge debe ser un número entre 0 y 100, con hasta 2 decimales.",
  "라운지 포인트 지급률": "Tasa de recompensa de puntos de lounge",
  "라운지 포인트 지급률 저장 실패": "No se pudo guardar la tasa de recompensa de puntos de lounge",
  "라운지포인트": "Puntos de lounge",
  "레이크백": "Rakeback",
  "로그아웃": "Cerrar sesión",
  "로그인": "Iniciar sesión",
  "로그인 실패: ": "Error de inicio de sesión: ",
  "로딩 중...": "Cargando...",
  "로딩중...": "Cargando...",
  "를 색상별로 누적 표시)": "por color)",
  "링크 열기": "Abrir enlace",
  "링크:": "Enlace:",
  "링크는 http:// 또는 https:// 로 시작해야 해.": "El enlace debe comenzar por http:// o https://.",
  "만료": "Caducado",
  "만료일:": "Caduca el:",
  "메모": "Nota",
  "메인 영역": "Área principal",
  "명": "usuarios",
  "무한(30일 갱신)": "Infinito (renovación cada 30 días)",
  "무한(infinite) 항목(상시 노출)": "Elementos infinitos (siempre visibles)",
  "미결제": "No pagado",
  "미리보기": "Vista previa",
  "미션 RUN 생성 실패": "No se pudo crear el RUN de misión",
  "미션 cfg 저장 실패": "No se pudo guardar la configuración de la misión",
  "미션 상금 분배(프론트 계산)": "Distribución del premio de la misión (cálculo del front-end)",
  "미션 상태 조회 실패": "No se pudo cargar el estado de la misión",
  "미션 총 베팅금(target_total_bet)을 입력": "Introduzca la apuesta total de la misión (target_total_bet)",
  "미입력시 자동": "Automático si está vacío",
  "받는 지갑": "Wallet receptor",
  "받는쪽 (to)": "Receptor (to)",
  "발생시각": "Ocurrido el",
  "배경 색상": "Color de fondo",
  "배경 이미지 URL": "URL de imagen de fondo",
  "배경 타입": "Tipo de fondo",
  "백엔드에 종료 API가 있어야 실제 중지됨": "Para detener realmente se requiere una API de parada en el backend.",
  "보내는 지갑": "Wallet remitente",
  "보낸쪽 (from)": "Remitente (from)",
  "복사": "Copiar",
  "복사 실패(브라우저 권한 확인)": "Error al copiar (compruebe los permisos del navegador)",
  "본문": "Contenido",
  "본문 내용을 입력하세요": "Introduzca el contenido",
  "본문 블록": "Bloques de contenido",
  "본문을 입력해줘.": "Introduzca el contenido.",
  "북미": "Norteamérica",
  "분배 비율": "Tasa de distribución",
  "분배 비율(상대 %)": "Tasa de distribución (relativa %)",
  "불러오기 실패": "No se pudo cargar",
  "불러오는 중…": "Cargando…",
  "비밀번호": "Contraseña",
  "비밀번호(미입력 시 변경 안 함)": "Contraseña (dejar en blanco para no cambiarla)",
  "비워두면 클릭 이동 없음": "Déjelo vacío para no tener enlace al hacer clic",
  "비활성": "Desactivado",
  "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "Para evitar errores, recomendamos volver a iniciar antes de continuar.",
  "삭제": "Eliminar",
  "삭제 실패": "Error al eliminar",
  "삭제됨": "Eliminado",
  "상단 고정(📌)": "Fijar arriba (📌)",
  "상세": "Detalles",
  "상시": "Siempre",
  "상위 에이전트:": "Agente superior:",
  "상위 에이전트의 수수료(": "Comisión del agente superior (",
  "상태": "Estado",
  "상태 보기 (테이블 미션 raw)": "Ver estado (misión de mesa raw)",
  "새 공지 작성": "Crear nuevo aviso",
  "새 광고 등록": "Crear nuevo anuncio",
  "새 전광판 등록": "Crear nueva marquesina",
  "새로고침": "Actualizar",
  "색상": "Color",
  "생성": "Crear",
  "생성 (미체크 시 일반 유저 생성)": "Crear (sin marcar = usuario normal)",
  "생성 실패: ": "Error al crear: ",
  "생성 에러:": "Error de creación:",
  "생성 중...": "Creando...",
  "생성 중…": "Creando…",
  "서버 오류": "Error del servidor",
  "서버로 전송될 preset 문자열(콤마 구분)": "Cadena de preset que se enviará al servidor (separada por comas)",
  "선택 입력": "Entrada opcional",
  "세컨드 비밀번호(옵션)": "Contraseña secundaria (opcional)",
  "소속 유저": "Usuarios asignados",
  "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "Si difiere de la dirección de wallet usada para la transferencia, puede perder fondos. Compruébelo de nuevo antes de enviar la solicitud.",
  "송금 완료 후 해당 버튼을 눌러주세요.": "Pulse este botón después de completar la transferencia.",
  "수량": "Cantidad",
  "수수료": "Comisión",
  "수수료 수정": "Editar comisión",
  "수수료 수정 실패": "No se pudo editar la comisión",
  "수정": "Editar",
  "수정 모드": "Modo de edición",
  "수정(설정)": "Editar (configuración)",
  "시간 설정": "Configuración de tiempo",
  "시간 설정이 올바르지 않습니다.": "La configuración de tiempo no es válida.",
  "시작": "Inicio",
  "시작(로컬)": "Inicio (local)",
  "시작(생성)": "Inicio (crear)",
  "시작일": "Fecha de inicio",
  "신규 작성": "Nuevo borrador",
  "썸네일 이미지": "Imagen en miniatura",
  "아래로": "Abajo",
  "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "No se pudo subir el icono (compruebe la API de carga del servidor)",
  "아이콘 파일은 1MB 이하로 올려주세요.": "El archivo del icono debe tener 1 MB o menos.",
  "아이콘(로컬 업로드/URL)": "Icono (carga local/URL)",
  "아프리카": "África",
  "언어": "Idioma",
  "업로드": "Subir",
  "업로드 URL을 받지 못했습니다.": "No se recibió la URL de carga.",
  "업로드 URL을 받지 못했어.": "No se recibió la URL de carga.",
  "업로드 비용": "Coste de carga",
  "업로드/게시": "Subir/Publicar",
  "업로드중...": "Subiendo...",
  "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "Después de subir, /uploads/... se completa automáticamente (o introduzca la URL directamente).",
  "에이전트": "Agente",
  "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Introduzca la tasa de distribución del agente (agent_share) (p. ej., 0.2 = 20%)",
  "에이전트 상금풀(": "Fondo de premios del agente (",
  "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "Se requiere conexión con la API para bloquear/desbloquear agentes.\n(Actualmente solo se admite el bloqueo de usuarios.)",
  "에이전트로 생성": "Crear como agente",
  "예: 25": "p. ej., 25",
  "예: AGT3001 또는 user123": "p. ej., AGT3001 o user123",
  "예: HOT": "p. ej., HOT",
  "예: KR / US / JP / ALL": "p. ej., KR / US / JP / ALL",
  "예: NEW YEAR EVENT START!": "p. ej., ¡COMIENZA EL EVENTO DE AÑO NUEVO!",
  "예: VIP NLH 1/2": "p. ej., VIP NLH 1/2",
  "예: 메인 KR 모바일 상단 배너": "p. ej., banner superior móvil principal KR",
  "예: 오늘만 레이크 0%": "p. ej., 0% de rake solo hoy",
  "예: 🔥 12/31 이벤트 진행중": "p. ej., 🔥 evento 12/31 en curso",
  "예: 🔧HOT": "p. ej., 🔧HOT",
  "예약": "Programado",
  "예약 tick": "Tick de programación",
  "예약 보류": "Programación pendiente",
  "예약 사용": "Usar programación",
  "예약 상태면 startAt(시작일시)를 넣어줘.": "Si el estado es programado, introduzca startAt.",
  "예약 시간이 올바르지 않습니다.": "La hora programada no es válida.",
  "예약 없음": "Sin programación",
  "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "Sin programación → se establece automáticamente en running de inmediato.",
  "예약(reserve_time_utc)": "Programación (reserve_time_utc)",
  "예약/상태": "Programación/Estado",
  "예약보류": "Programación pendiente",
  "오래된순": "Más antiguos primero",
  "왼쪽에서 공지를 선택해줘.": "Seleccione un aviso a la izquierda.",
  "왼쪽에서 광고를 선택해줘.": "Seleccione un anuncio a la izquierda.",
  "요소(최대 4개)": "Elementos (máx. 4)",
  "용량": "Tamaño",
  "위로": "Arriba",
  "유럽": "Europa",
  "유저 관리": "Gestión de usuarios",
  "유저코드": "Código de usuario",
  "유효 인포메이션 버튼:": "Botones de información válidos:",
  "을 눌러야 서버에 반영됨": " debe pulsarse para aplicar los cambios al servidor.",
  "이 노드의 기본 수수료 비율(%)": "Tasa de comisión predeterminada (%) para este nodo",
  "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "Establecer de una vez todas las comisiones de jugadores bajo este agente",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "No tiene permiso para acceder a esta página.",
  "이동 URL": "URL de destino",
  "이미지": "Imagen",
  "이미지 URL": "URL de imagen",
  "이미지 alt 텍스트": "Texto alt de imagen",
  "이미지 넣기": "Insertar imagen",
  "이미지 블록": "Bloque de imagen",
  "이미지 업로드 중...": "Subiendo imagen...",
  "이미지 업로드에 실패했습니다.": "No se pudo subir la imagen.",
  "이미지 업로드중...": "Subiendo imagen...",
  "이미지 없음": "Sin imagen",
  "이미지 열기": "Abrir imagen",
  "이미지 파일만 등록할 수 있어.": "Solo se pueden registrar archivos de imagen.",
  "이미지 파일만 업로드할 수 있어.": "Solo se pueden subir archivos de imagen.",
  "이미지(URL)": "Imagen (URL)",
  "이미지는 5MB 이하만 업로드할 수 있어.": "Las imágenes deben tener 5 MB o menos.",
  "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "Las imágenes se muestran en el contenido con el formato [image-number].",
  "이전": "Anterior",
  "인포 버튼 시간 설정이 올바르지 않습니다.": "La configuración de tiempo del botón de información no es válida.",
  "인포 버튼 프리셋 수정": "Editar preset del botón de información",
  "인포 버튼 프리셋 수정 실패": "No se pudo editar el preset del botón de información",
  "인포메이션 버튼(선택)": "Botón de información (opcional)",
  "인포버튼 없음": "Sin botón de información",
  "인포버튼 프리셋 수정": "Editar preset del botón de información",
  "인포버튼 프리셋 수정 실패": "No se pudo editar el preset del botón de información",
  "인포카드 추가": "Añadir tarjeta informativa",
  "인포카드 추가 실패": "No se pudo añadir la tarjeta informativa",
  "인포카드 타이머": "Temporizador de tarjeta informativa",
  "일": "días",
  "일 /": "días /",
  "일/": "días/",
  "일반 자산": "Activo principal",
  "임시": "Borrador",
  "임시저장": "Borrador",
  "입력값을 확인해 주세요.": "Compruebe los valores introducidos.",
  "자산": "Activo",
  "자산 으로 변환": "Convertir a activo",
  "자산 타입": "Tipo de activo",
  "자산기록": "Libro mayor de activos",
  "작성": "Crear",
  "작성일:": "Creado el:",
  "작성자": "Autor",
  "잠금 비밀번호": "Contraseña de bloqueo",
  "재게시": "Volver a publicar",
  "재시작": "Reiniciar",
  "저장": "Guardar",
  "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "Al guardar, se convierte automáticamente al token de URL de imagen real.",
  "저장 중...": "Guardando...",
  "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "Guardado. La hora de referencia utiliza la configuración del temporizador de la tarjeta informativa anterior (timerMode/timerEndUtc).",
  "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Guardar es gratuito; el coste se descuenta del activo del agente solo en la primera publicación.",
  "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Guardar es gratuito. El coste se descuenta del activo del agente solo en la primera carga/publicación.",
  "저장중...": "Guardando...",
  "적용": "Aplicar",
  "전광판": "Marquesina",
  "전광판 관리": "Gestión de marquesina",
  "전광판 등록 실패": "No se pudo crear la marquesina",
  "전광판 목록 조회 실패": "No se pudo cargar la lista de marquesinas",
  "전광판 삭제 실패": "No se pudo eliminar la marquesina",
  "전광판 수정 실패": "No se pudo editar la marquesina",
  "전체": "Todos",
  "전체 상태": "Estado general",
  "접기": "Contraer",
  "정렬": "Alineación",
  "정렬 변경에 실패했어.": "No se pudo cambiar el orden.",
  "정렬 저장": "Guardar orden",
  "정렬 저장 실패": "No se pudo guardar el orden",
  "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "Las flechas de ordenación solo funcionan dentro del mismo grupo de área/dispositivo/país.",
  "정보 수정 실패": "No se pudo editar la información",
  "정보수정": "Editar información",
  "정상": "Normal",
  "제거": "Eliminar",
  "제목": "Título",
  "제목을 입력하세요": "Introduzca un título",
  "제목을 입력해줘.": "Introduzca un título.",
  "조회": "Buscar",
  "종료(로컬)": "Fin (local)",
  "종료일": "Fecha de fin",
  "줄바꿈 그대로 표시됨.": "Se conservan los saltos de línea.",
  "중동": "Oriente Medio",
  "중앙아시아": "Asia Central",
  "중지": "Detener",
  "중지(삭제)": "Detener (eliminar)",
  "중지됨": "Detenido",
  "지갑 주소": "Dirección de wallet",
  "지금": "Ahora",
  "지급": "Acreditar",
  "지급 실패": "Error al acreditar",
  "차감": "Debitar",
  "차감 실패": "Error al debitar",
  "차단": "Bloquear",
  "차단 해제": "Desbloquear",
  "차단됨": "Bloqueado",
  "처리 중...": "Procesando...",
  "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "Si no se marca, esto se aplicará solo a las mesas nuevas que se creen a partir de ahora.",
  "초기화": "Restablecer",
  "초안": "Borrador",
  "총": "Total",
  "총 상금풀(1.5%):": "Fondo total de premios (1.5%):",
  "총베팅액:": "Apuesta total:",
  "최근순": "Más recientes primero",
  "추가": "Añadir",
  "출금하기": "Retirar",
  "충전 하기": "Depositar",
  "취소": "Cancelado",
  "카테고리": "Categoría",
  "크기(px)": "Tamaño (px)",
  "클릭 시 출금이 시작 됩니다.": "La retirada comienza al hacer clic.",
  "클릭 이동 URL(link_url)": "URL de destino al hacer clic (link_url)",
  "클릭 이동 링크(URL)": "Enlace de destino al hacer clic (URL)",
  "클릭하면 등록 모달": "Haga clic para abrir el modal de registro",
  "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "Haga clic para establecer la hora de referencia de visualización en esta fecha.",
  "클릭하여 이미지 업로드": "Haga clic para subir una imagen",
  "타이머 없음": "Sin temporizador",
  "타이머 타입": "Tipo de temporizador",
  "타이머(존재유무만)": "Temporizador (solo existencia)",
  "타이머는": "El temporizador es",
  "타입": "Tipo",
  "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "Una transacción de prueba envía 0.01 USDT para confirmar que el depósito es correcto antes de comenzar.",
  "테이블 관리": "Gestión de mesas",
  "테이블 그룹 목록 조회 실패": "No se pudo cargar la lista de grupos de mesas",
  "테이블 그룹 생성 실패": "No se pudo crear el grupo de mesas",
  "테이블 그룹 생성 완료": "Grupo de mesas creado correctamente",
  "테이블 그룹 코드 생성 실패": "No se pudo generar el código del grupo de mesas",
  "테이블 그룹이 없습니다.": "No hay grupos de mesas.",
  "테이블 미션": "Misión de mesa",
  "테이블 미션 RUN 생성 실패": "No se pudo crear el RUN de misión de mesa",
  "테이블 미션 RUN 중지 실패": "No se pudo detener el RUN de misión de mesa",
  "테이블 미션 cfg 저장 실패": "No se pudo guardar la configuración de la misión de mesa",
  "테이블 미션 상금 분배(프론트 계산)": "Distribución del premio de la misión de mesa (cálculo del front-end)",
  "테이블 미션 상태 조회 실패": "No se pudo cargar el estado de la misión de mesa",
  "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Introduzca la tasa de distribución del agente de la misión de mesa (agent_share) (p. ej., 0.2 = 20%)",
  "테이블 미션 총 베팅금(target_total_bet)을 입력": "Introduzca la apuesta total de la misión de mesa (target_total_bet)",
  "텍스트": "Texto",
  "텍스트 블록": "Bloque de texto",
  "텍스트 스타일": "Estilo de texto",
  "파일명": "Nombre de archivo",
  "판매": "Vendido",
  "페이지": "Página",
  "페이지 크기": "Tamaño de página",
  "펼치기": "Expandir",
  "폰트스타일": "Estilo de fuente",
  "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "carpeta, y solo se almacenan los metadatos/ruta en la DB.",
  "표시 기준 시간": "Hora de referencia de visualización",
  "표시 순서(order)": "Orden de visualización (order)",
  "표시 여부만": "Solo visibilidad",
  "표시명": "Nombre para mostrar",
  "표시할 기록이 없습니다.": "No hay registros para mostrar.",
  "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Prueba de front-end: procesar transferencia completada (antes de conectar el backend)",
  "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Prueba de front-end: procesar inicio de retirada (antes de conectar el backend)",
  "프리셋 수정": "Editar preset",
  "프리셋(배경/요소/URL)": "Preset (fondo/elementos/URL)",
  "플레이어 상금풀(": "Fondo de premios de jugadores (",
  "플레이어 수수료 설정": "Configuración de comisión de jugadores",
  "하위": "Subcuenta",
  "하위 계정 생성": "Crear subcuenta",
  "하위 생성": "Crear subcuenta",
  "하위 생성 (부모:": "Crear subcuenta (superior:",
  "하이라이트 메세지": "Mensaje destacado",
  "하이라이트 포인트": "Punto destacado",
  "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "No podemos responsabilizarnos por los fondos afectados por este problema. Compruébelo de nuevo antes de continuar.",
  "현재 index 값들을 서버에 저장": "Guardar los valores de índice actuales en el servidor",
  "현재 라운지 포인트 %": "Puntos de lounge actuales %",
  "현재 활성 테이블에도 즉시 적용": "Aplicar inmediatamente también a las mesas activas actuales",
  "확인용 테스트 거래 시작": "Iniciar transacción de prueba de verificación",
  "활성 RUN이 없습니다.": "No hay ningún RUN activo.",
  "회원 정보 수정": "Editar información del miembro",
  "🔐 어드민 로그인": "🔐 Inicio de sesión de administrador",
  "요청 실패 ({status})": "Solicitud fallida ({status})",
  "지급 (대상: {targetId})": "Acreditar (objetivo: {targetId})",
  "차감 (대상: {targetId})": "Debitar (objetivo: {targetId})",
  "본인 {id}": "Yo {id}",
  "하위 {id}": "Subcuenta {id}",
  "테이블 그룹 삭제?\n({displayCode})": "¿Eliminar el grupo de mesas?\n({displayCode})",
  "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "El grupo se eliminó, pero falló la limpieza de Redis. (code={code})",
  "그룹 미션 RUN 중지?\nrun_id={runId}": "¿Detener el RUN de misión de grupo?\nrun_id={runId}",
  "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "Ya hay un RUN de misión de mesa en ejecución.\n(run_id={runId})\n¿Reiniciarlo (eliminar el RUN existente y crear uno nuevo)?",
  "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "¿Detener el RUN de misión de mesa (se aplica a todo el grupo)?\n(display_code={displayCode})",
  "무한(약 {days}일 단위 갱신)": "Infinito (se renueva aproximadamente cada {days} días)",
  "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "La tarifa de carga de {fee} USDT se descontará de UserDB.asset y se publicará durante {days} días desde la fecha de pago. ¿Publicar ahora?",
  "전광판 삭제?\n(id={id})": "¿Eliminar la marquesina?\n(id={id})",
  "이미지 업로드 실패: {message}": "Error al subir la imagen: {message}",
  "광고를 삭제할까?\n\n- {label}": "¿Eliminar este anuncio?\n\n- {label}",
  "{targetId} 삭제하시겠습니까?": "¿Eliminar {targetId}?",
  "라운지 저장에 실패했습니다.\n{message}": "No se pudo guardar el lounge.\n{message}",
  "라운지 게시에 실패했습니다.\n{message}": "No se pudo publicar el lounge.\n{message}",
  "이 라운지 글을 중지할까요?\n\n- {title}": "¿Detener esta publicación de lounge?\n\n- {title}",
  "라운지 중지에 실패했습니다.\n{message}": "No se pudo detener la publicación de lounge.\n{message}",
  "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "¿Marcar esta publicación de lounge como eliminada?\n\n- {title}",
  "라운지 삭제에 실패했습니다.\n{message}": "No se pudo eliminar la publicación de lounge.\n{message}",
  "공지 목록을 불러오지 못했어.\n{message}": "No se pudo cargar la lista de avisos.\n{message}",
  "공지 저장에 실패했어.\n{message}": "No se pudo guardar el aviso.\n{message}",
  "공지 삭제할까?\n\n- {title}": "¿Eliminar este aviso?\n\n- {title}",
  "공지 삭제에 실패했어.\n{message}": "No se pudo eliminar el aviso.\n{message}",
  "인포카드": "Tarjeta informativa",
  "인포카드 삭제": "Eliminar tarjeta informativa",
  "인포카드 삭제 실패": "No se pudo eliminar la tarjeta informativa",
  "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "¿Eliminar esta tarjeta informativa? También se eliminarán todas las variantes de escritorio/móvil y de idioma de la misma tarjeta. El grupo de mesas y las mesas de juego no se eliminarán.",
  "요청 처리 중 오류가 발생했습니다.": "Se produjo un error al procesar la solicitud.",
  "완료": "Completado",
  "진행중": "En curso",
  "검토필요": "Requiere revisión",
  "실패": "Fallido",
  "환전": "Retirada",
  "충전": "Depósito",
  "USDT TRC20 메인넷": "USDT TRC20 Mainnet",
  "정책 확인 중": "Comprobando política",
  "x3 베팅요건 충족": "Requisito de apuesta x3 cumplido",
  "x3 남은 베팅 {amount}": "Apuesta restante x3 {amount}",
  "입금주소 발급 실패": "No se pudo emitir la dirección de depósito",
  "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "Se ha emitido una dirección de depósito. Envíe los fondos a esa dirección y luego pulse el botón de finalización.",
  "먼저 입금주소를 발급하세요.": "Primero emita una dirección de depósito.",
  "충전 요청 실패": "Solicitud de depósito fallida",
  "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "Solicitud de depósito registrada. El importe acreditado real se basará en el importe on-chain verificado por el bridge.",
  "환전 요청 실패": "Solicitud de retirada fallida",
  "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "Solicitud de retirada registrada. Solo continuará después de cumplir el requisito x3 y las comprobaciones del importe retirable en la DB.",
  "취소 실패": "Cancelación fallida",
  "요청 취소 처리를 보냈습니다.": "Se ha enviado la solicitud de cancelación.",
  "재확인 실패": "Recomprobación fallida",
  "입금 재확인 요청을 보냈습니다.": "Se ha enviado la solicitud de recomprobación del depósito.",
  "어드민 결제": "Pago del administrador",
  "내 자산": "Mi activo",
  "출금가능 검증금액": "Importe retirable verificado",
  "x3 베팅요건": "Requisito de apuesta x3",
  "운영수익 정책": "Política de ingresos operativos",
  "개인 출금가능금액에 미가산": "No se añade al importe personal retirable",
  "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "Los depósitos directos del administrador registran el mismo requisito de apuesta x3 que los usuarios. Los ingresos operativos, como comisiones del juego, rake y comisiones, no se añaden al importe personal retirable del administrador y se separan en un libro mayor de ingresos.",
  "결제 네트워크": "Red de pago",
  "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "El entorno de producción actual utiliza únicamente USDT TRC20 Mainnet.",
  "환전하기": "Retirar",
  "충전하기": "Depositar",
  "Admin Charge": "Depósito del administrador",
  "내 송금 지갑 주소": "Mi dirección de wallet de envío",
  "선택 입력: 내가 송금하는 지갑 주소": "Opcional: dirección de wallet desde la que envío",
  "예상 금액": "Importe estimado",
  "선택 입력: 실제 반영은 온체인 입금액 기준": "Opcional: el crédito real se basa en el importe del depósito on-chain",
  "발급 중...": "Emitiendo...",
  "입금주소 발급": "Emitir dirección de depósito",
  "입금 지갑 주소": "Dirección de wallet de depósito",
  "입금주소 발급 후 표시됩니다.": "Se mostrará después de emitir una dirección de depósito.",
  "복사 실패": "Error al copiar",
  "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "Envíe únicamente a la dirección {networkLabel} mostrada. Los depósitos directos del administrador también están sujetos al requisito de apuesta x3.",
  "등록 중...": "Registrando...",
  "송금 완료 후 충전 확인 요청": "Solicitar comprobación del depósito después de la transferencia",
  "Admin Exchange": "Retirada del administrador",
  "환전 받을 USDT TRC20 메인넷 주소": "Dirección USDT TRC20 Mainnet para recibir el retiro",
  "환전 금액": "Importe de retirada",
  "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "La retirada solo continúa cuando se superan las comprobaciones del activo en DB, el importe retirable verificado y el requisito de apuesta x3. Los ingresos operativos no se añaden al importe personal retirable.",
  "환전 요청": "Solicitar retirada",
  "최근 결제 요청": "Solicitudes de pago recientes",
  "구분": "Tipo",
  "주소": "Dirección",
  "요청ID": "ID de solicitud",
  "불러오는 중...": "Cargando...",
  "결제 요청 내역이 없습니다.": "No se encontraron solicitudes de pago.",
  "재확인": "Recomprobar",
  "* 배경 이미지는 최대 5MB까지 업로드 가능합니다. 기존 URL 직접 입력 방식도 유지됩니다.": "* Las imágenes de fondo pueden subirse hasta 5 MB. También se admite la introducción directa de URL.",
  "* 이 항목의 배경은 선택한 디바이스/언어 타겟에만 적용됩니다. 국가값은 현재 사용하지 않으므로 저장 시 ALL로 고정됩니다. desktop/mobile 또는 언어별로 다르게 쓰려면 각 타겟 항목을 따로 생성해서 배경을 저장하세요.": "* Este fondo se aplica únicamente al objetivo de dispositivo/idioma seleccionado. Actualmente no se usa el país y se guarda como ALL. Cree un elemento de objetivo separado para cada fondo de desktop/mobile o específico por idioma.",
  "/events/avatar-reward 또는 https://...": "/events/avatar-reward o https://...",
  "8자 이상 입력": "Introduzca al menos 8 caracteres",
  "BB 단위 cap입니다. 0이면 cap 없음.": "Es el cap en unidades BB. Introduzca 0 para no aplicar cap.",
  "Event Fee %는 0~100 사이 숫자여야 합니다.": "Event Fee % debe estar entre 0 y 100.",
  "Rake %는 0~100 사이 숫자여야 합니다.": "Rake % debe estar entre 0 y 100.",
  "Rake Cap BB는 0 이상의 숫자여야 합니다.": "Rake Cap BB debe ser 0 o superior.",
  "Redis 이메일 큐": "Cola de correo de Redis",
  "SMTP 실패 재시도": "Reintentar fallos de SMTP",
  "[선택]": "[Opcional]",
  "[필수]": "[Obligatorio]",
  "all / 데스크톱+모바일": "all / Escritorio + Móvil",
  "all / 전체 언어": "all / Todos los idiomas",
  "desktop / 데스크톱": "desktop / Escritorio",
  "ko / 한국어": "ko / Coreano",
  "lv2 에이전트 계정에만": "Solo para la cuenta de agente lv2",
  "lv2 추천 보상 포인트": "Puntos de recompensa por referidos lv2",
  "mobile / 모바일": "mobile / Móvil",
  "{amount} USDT 전액 자산으로 변환": "Convertir los {amount} USDT completos a activos",
  "{amount} USDT 포인트 전액을 현재 에이전트 자산으로 변환할까요?": "¿Convertir todos los {amount} USDT en puntos a los activos del agente actual?",
  "가 적립됩니다. 한 유저는 한 번만 스탬프 처리됩니다.": "se acreditarán. Cada usuario solo se marca una vez.",
  "가입 유저가 없습니다.": "No hay usuarios registrados.",
  "가입 현황을 불러오지 못했습니다.": "No se pudo cargar el estado de registro.",
  "가입 후 승인 상태를 확인할 수 있습니다.": "Puede comprobar el estado de aprobación después del registro.",
  "가입일": "Fecha de registro",
  "각 칸은 별도 인포 버튼 항목입니다. 없으면 현재 설정을 복제해서 생성하고, 있으면 해당 항목을 열어 배경 이미지를 따로 바꿀 수 있습니다.": "Cada celda es un elemento de botón de información independiente. Si no existe, se crea copiando la configuración actual; si existe, puede abrirlo para cambiar su fondo por separado.",
  "개별 발송 가능": "Envío individual disponible",
  "개별 발송 결과를 불러오는 중...": "Cargando resultados de envíos individuales...",
  "개별 발송 기록이 없습니다.": "No hay registros de envíos individuales.",
  "개별 발송 이력을 불러오지 못했습니다.": "No se pudo cargar el historial de envíos individuales.",
  "개인정보 수집 및 이용 동의": "Consentimiento para la recopilación y uso de información personal",
  "개인정보 수집 및 이용 안내": "Aviso sobre recopilación y uso de información personal",
  "개인정보 안내": "Aviso de privacidad",
  "검색 결과가 없습니다.": "No hay resultados de búsqueda.",
  "검색 중": "Buscando",
  "계정 문제는 상위 관리자에게 문의": "Para problemas con la cuenta, contacte con su administrador superior",
  "계정 상태와 접근 권한을 확인합니다.": "Compruebe el estado de la cuenta y los permisos de acceso.",
  "계정 유형과 필수 정보를 확인한 뒤 생성해 주세요. 생성된 계정은 즉시 현재 에이전트 아래에 연결됩니다.": "Compruebe el tipo de cuenta y la información obligatoria antes de crearla. La nueva cuenta se vincula inmediatamente bajo el agente actual.",
  "계정 입력": "Información de la cuenta",
  "계정 확인 및 복구에 사용됩니다.": "Se utiliza para verificar y recuperar la cuenta.",
  "계정과 복구 정보를 정확히 입력합니다.": "Introduzca correctamente la información de la cuenta y de recuperación.",
  "계정은 본인 또는 정당한 권한을 가진 사용자가 생성해야 하며, 계정 공유·권한 오용·서비스 운영 방해 행위는 제한될 수 있습니다.": "Las cuentas deben ser creadas por su titular o por una persona con autorización legítima. El uso compartido de cuentas, el uso indebido de permisos y las acciones que interfieran con el funcionamiento del servicio pueden estar restringidos.",
  "공용 기기에서는 로그인 상태 유지를 선택하지 마세요.": "No seleccione Mantener sesión iniciada en un dispositivo compartido.",
  "관리 도구 접속": "Acceder a herramientas de administración",
  "관리 서비스를 위한": "Para servicios de administración",
  "관리 화면에 표시되는 이름입니다.": "Este nombre se muestra en la interfaz de administración.",
  "관리자 계정 정보를 입력해 주세요.": "Introduzca la información de la cuenta de administrador.",
  "관리자 로그인 안내": "Aviso de inicio de sesión de administrador",
  "관리자 메뉴": "Menú de administrador",
  "관리자 메뉴 열기": "Abrir menú de administrador",
  "관리자 승인": "Aprobación del administrador",
  "관리자 승인이 완료된 계정만 접속할 수 있습니다.": "Solo pueden acceder las cuentas aprobadas por un administrador.",
  "관리자 승인이 필요한 계정은 승인 완료 후 로그인할 수 있습니다.": "Las cuentas que requieren aprobación del administrador pueden iniciar sesión una vez completada la aprobación.",
  "관리자 아이디 입력": "Introduzca el ID de administrador",
  "관리자 전용 로그인": "Inicio de sesión de administrador",
  "관리자 홈": "Inicio del administrador",
  "권한 확인": "Comprobación de permisos",
  "기존": "Existente",
  "기존 타겟 항목 열기": "Abrir elemento de objetivo existente",
  "내 계정": "Mi cuenta",
  "내부 팝업 URL": "URL de popup interno",
  "노출 타겟 / 개별 배경 기준": "Objetivo de exposición / Fondo individual",
  "누적 획득 포인트": "Puntos totales obtenidos",
  "닉네임은 2~16자로 입력해 주세요.": "Introduzca un apodo de entre 2 y 16 caracteres.",
  "다음 20 USDT까지": "Hasta los próximos 20 USDT",
  "다음 보상 대기 유저": "Usuarios pendientes de la siguiente recompensa",
  "대기": "Pendiente",
  "대기열": "Cola",
  "대기열 등록 중...": "Añadiendo a la cola...",
  "대상": "Objetivo",
  "대소문자를 구분하여 정확하게 입력해 주세요.": "Introdúzcalo exactamente respetando mayúsculas y minúsculas.",
  "데스크톱": "Escritorio",
  "동일한 비밀번호를 입력해 주세요.": "Introduzca la misma contraseña.",
  "등록 이메일 없음": "Sin email registrado",
  "디바이스": "Dispositivo",
  "디바이스/언어별 배경 빠른 관리": "Gestión rápida de fondos por dispositivo/idioma",
  "로그인 및 주요 관리 활동은 보안을 위해 기록됩니다.": "Los inicios de sesión y las principales actividades administrativas se registran por motivos de seguridad.",
  "로그인 아이디 저장": "Recordar ID de inicio de sesión",
  "로그인 중…": "Iniciando sesión…",
  "로그인 화면으로 돌아가기": "Volver al inicio de sesión",
  "로그인 화면으로 이동": "Ir al inicio de sesión",
  "로그인에 사용할 아이디입니다.": "Este es el ID utilizado para iniciar sesión.",
  "로그인이 반복해서 실패하면 계정이 일시적으로 잠길 수 있습니다. 관리자에게 계정 상태를 확인해 주세요.": "Los intentos fallidos repetidos de inicio de sesión pueden bloquear temporalmente la cuenta. Pida a un administrador que compruebe el estado de la cuenta.",
  "를 입력하세요.": "Introduzca",
  "링크 복사": "Copiar enlace",
  "마케팅 수신 동의": "Consentimiento de marketing",
  "마케팅 수신 동의 유저 {count}명": "{count} usuarios con consentimiento de marketing",
  "마케팅 이메일 수신 동의 대상자가 없습니다.": "No hay usuarios que hayan aceptado recibir emails de marketing.",
  "메일 작성": "Redactar email",
  "메일 제목": "Asunto del email",
  "메일 제목과 본문을 입력해 주세요.": "Introduzca el asunto y el contenido del email.",
  "명마다": "usuarios cada",
  "모바일": "Móvil",
  "미생성": "No creado",
  "미션 상금 수혜자 설정": "Configuración de beneficiarios del premio de misión",
  "미인증": "No verificado",
  "받은편지함에 표시될 제목": "Asunto que se mostrará en la bandeja de entrada",
  "발급받은 관리자 계정 아이디를 입력해 주세요.": "Introduzca el ID de cuenta de administrador emitido.",
  "발급받은 관리자 아이디를 입력합니다.": "Introduzca el ID de administrador emitido.",
  "발송 대상": "Destinatarios",
  "발송 미리보기": "Vista previa del envío",
  "발송 이력": "Historial de envíos",
  "발송할 내용을 입력하세요.": "Introduzca el contenido que desea enviar.",
  "발송할 유저를 선택해 주세요.": "Seleccione un usuario al que enviar.",
  "배경 없음": "Sin fondo",
  "배경 이미지 업로드 / URL": "Subir imagen de fondo / URL",
  "배경 이미지 업로드 실패 (서버 업로드 API 확인 필요)": "No se pudo subir la imagen de fondo (compruebe la API de carga del servidor)",
  "배경 이미지 파일은 5MB 이하로 올려주세요.": "Suba una imagen de fondo de 5 MB o menos.",
  "배치": "Lote",
  "버튼 URL": "URL del botón",
  "버튼 문구": "Texto del botón",
  "변환": "Convertir",
  "변환 중...": "Convirtiendo...",
  "변환 후 자산": "Activos después de la conversión",
  "보기": "Ver",
  "보안 안내": "Aviso de seguridad",
  "보유 기간": "Período de conservación",
  "보호됨": "Protegido",
  "본 메일은 Night Poker Club에서 발송되었습니다.": "Este email fue enviado por Night Poker Club.",
  "본문 제목": "Título del contenido",
  "분배식": "Fórmula de distribución",
  "분배식은 agent_id:percent 형식이며 percent 합계는 1 또는 100이어야 합니다. 예: 1002:0.7 / 1001:0.3": "La fórmula de distribución debe usar el formato agent_id:percent y la suma de los porcentajes debe ser 1 o 100. Ejemplo: 1002:0.7 / 1001:0.3",
  "비밀번호 다시 입력": "Volver a introducir la contraseña",
  "비밀번호 입력": "Introducir contraseña",
  "비밀번호 확인": "Confirmar contraseña",
  "비밀번호 확인 값이 일치하지 않습니다.": "La confirmación de la contraseña no coincide.",
  "비밀번호는 8자 이상 입력해 주세요.": "Introduzca una contraseña de al menos 8 caracteres.",
  "비밀번호는 다른 서비스와 다르게 설정해 주세요.": "Utilice una contraseña distinta de la de otros servicios.",
  "비워두면 메일 제목 사용": "Déjelo vacío para usar el asunto del email",
  "사용 가능 포인트": "Puntos disponibles",
  "사용 가능한 이메일 주소를 입력해 주세요.": "Introduzca una dirección de email válida.",
  "상금 수혜자": "Beneficiario del premio",
  "상위 에이전트: {id}": "Agente superior: {id}",
  "상위 에이전트가 전부 수령": "El agente superior recibe todo",
  "새 계정을 생성합니다.": "Crear una nueva cuenta.",
  "서비스 이용에 필요한 기본 정보를 입력해 주세요.": "Introduzca la información básica necesaria para usar el servicio.",
  "선택": "Seleccionar",
  "성공": "Éxito",
  "소속 에이전트": "Agente asignado",
  "수신 동의": "Consentido",
  "수신 미동의": "No consentido",
  "수신자": "Destinatario",
  "수집 항목": "Información recopilada",
  "수혜 방식": "Método de beneficiario",
  "수혜자 agent_id": "agent_id del beneficiario",
  "수혜자 agent_id를 입력하세요.": "Introduzca el agent_id del beneficiario.",
  "수혜자 설정 저장 실패": "No se pudo guardar la configuración del beneficiario",
  "슈퍼어드민 전용 · 이메일 워커 대기열 발송": "Solo superadmin · Enviar mediante la cola del worker de email",
  "스탬프": "Sello",
  "스탬프 완료": "Sellado",
  "스탬프 완료 유저": "Usuarios sellados",
  "승인 계정 확인": "Verificar cuenta aprobada",
  "승인된 관리자 계정 전용": "Solo cuentas de administrador aprobadas",
  "승인된 관리자 계정으로 로그인한 뒤 운영 대시보드와 관리 기능을 이용해 주세요.": "Inicie sesión con una cuenta de administrador aprobada para usar el panel de operaciones y las funciones de administración.",
  "승인된 범위의 운영 기능을 이용합니다.": "Utilice las funciones operativas dentro del ámbito aprobado.",
  "시도": "Intento",
  "실제 워커 템플릿 기준": "Basado en la plantilla real del worker",
  "아래 링크를 복사해 주세요.": "Copie el enlace de abajo.",
  "아바타 보상 이벤트 팝업 URL 적용": "Aplicar URL del popup del evento de recompensa de avatar",
  "아바타 보상 이벤트 팝업을 열려면 이동 URL에": "Para abrir el popup del evento de recompensa de avatar, introduzca esto en la URL de destino:",
  "아이디": "ID",
  "아이디, 닉네임, 비밀번호는 필수입니다. 2차 비밀번호는 필요한 경우에만 입력합니다.": "ID, apodo y contraseña son obligatorios. Introduzca una contraseña secundaria solo cuando sea necesario.",
  "아이디, 닉네임, 이메일, 비밀번호": "ID, apodo, email y contraseña",
  "아이디는 영문, 숫자, 밑줄을 사용해 4~20자로 입력해 주세요.": "Introduzca entre 4 y 20 caracteres usando letras, números y guiones bajos.",
  "아직 계정이 없으신가요?": "¿Aún no tiene una cuenta?",
  "아직 발송 이력이 없습니다.": "Aún no hay historial de envíos.",
  "아직 변환 기록이 없습니다.": "Aún no hay historial de conversiones.",
  "아직 적립 기록이 없습니다.": "Aún no hay historial de acumulación.",
  "안전한 관리 서비스": "Servicio de administración seguro",
  "약관 동의": "Consentimiento de términos",
  "에게 발송합니다.": "recibirá este mensaje.",
  "에이전트 가입 현황": "Estado de registro de agentes",
  "에이전트 계층과 소속 유저, 수수료, 자산 및 미션 상금 정책을 관리합니다.": "Gestione la jerarquía de agentes, usuarios asignados, comisiones, activos y políticas de premios de misión.",
  "에이전트 목록을 불러오지 못했습니다.": "No se pudo cargar la lista de agentes.",
  "에이전트 추가 상금 미지급": "No pagar premio adicional al agente",
  "에이전트 코드": "Código de agente",
  "여러 에이전트 분배 수령": "Distribuir entre varios agentes",
  "영문, 숫자, 특수문자 조합을 권장합니다.": "Se recomienda una combinación de letras, números y caracteres especiales.",
  "영문·숫자 4~20자": "4–20 letras y números",
  "예: 사이트 바로가기": "Ejemplo: Visitar sitio web",
  "예상 발송": "Envíos estimados",
  "오늘 조직 가입자": "Registros de la organización hoy",
  "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.": "Demasiadas solicitudes. Inténtelo de nuevo más tarde.",
  "우선순위": "Prioridad",
  "유저 검색": "Búsqueda de usuarios",
  "유저 검색에 실패했습니다.": "La búsqueda de usuarios falló.",
  "유저 코드": "Código de usuario",
  "유저 코드, 아이디, 닉네임": "Código de usuario, ID, apodo",
  "유저 코드, 아이디, 닉네임, 소속 에이전트 검색": "Buscar por código de usuario, ID, apodo o agente asignado",
  "이 설정은 유저 테이블 상금은 건드리지 않고, agent_share로 계산된 추가 상금의 수혜자만 결정합니다.": "Esta configuración no afecta a los premios de mesa de los usuarios; solo determina los beneficiarios del premio adicional calculado a partir de agent_share.",
  "이메일": "Email",
  "이메일 관리 정보를 불러오는 중...": "Cargando información de gestión de email...",
  "이메일 관리 정보를 불러오지 못했습니다.": "No se pudo cargar la información de gestión de email.",
  "이메일 마케팅 정보 수신": "Recibir información de marketing por email",
  "이메일 발송": "Enviar email",
  "이메일 발송 요청에 실패했습니다.": "La solicitud de envío de email falló.",
  "이메일 제목 미리보기": "Vista previa del asunto del email",
  "이메일을 발송할까요?\n\n대상: {target}\n제목: {subject}\n예상 발송: {count}건": "¿Enviar este email?\n\nObjetivo: {target}\nAsunto: {subject}\nEnvíos estimados: {count}",
  "이메일이 발송 대기열에 등록되었습니다.": "El email se añadió a la cola de envío.",
  "이미 계정이 있으신가요?": "¿Ya tiene una cuenta?",
  "이미 등록된 이메일입니다.": "Este email ya está registrado.",
  "이미 사용 중인 아이디입니다.": "Este ID ya está en uso.",
  "이용 목적": "Finalidad de uso",
  "이용 약관 동의": "Aceptar los Términos del servicio",
  "이용약관 동의": "Consentimiento de Términos del servicio",
  "이용약관과 개인정보 수집 및 이용에 동의해 주세요.": "Acepte los Términos del servicio y la recopilación y uso de información personal.",
  "인증 이메일 보유": "Tiene email verificado",
  "인증된 이메일이 없는 유저에게는 발송할 수 없습니다.": "No se puede enviar a un usuario sin una dirección de email verificada.",
  "인증된 이메일이 있고, 마케팅 이메일 수신에 동의했으며, 차단되지 않은 유저": "Usuarios con email verificado, consentimiento para emails de marketing y que no están bloqueados",
  "인증됨": "Verificado",
  "일시": "Fecha y hora",
  "입력한 정보는 계정 생성, 승인, 본인 확인 및 계정 복구 목적으로만 처리됩니다. 탈퇴 또는 보유 목적 달성 후 관계 법령에 따른 보관 기간을 제외하고 파기됩니다.": "La información introducida se procesa únicamente para la creación y aprobación de cuentas, verificación de identidad y recuperación de cuentas. Se elimina tras la baja o el cumplimiento de la finalidad de conservación, salvo los períodos exigidos por la ley.",
  "자기 직속 유저와 모든 하위 에이전트 소속 유저를 합산해 확인합니다.": "Vea el total combinado de sus usuarios directos y los usuarios asignados a todos los agentes descendentes.",
  "자산 변환 완료": "Conversión de activos completada",
  "작성한 이메일 본문이 여기에 표시됩니다.": "El contenido del email que redacte aparecerá aquí.",
  "재시도 대기": "Esperando reintento",
  "적립": "Acumulación",
  "적립됩니다.": "se acreditará.",
  "전용 회원가입 URL": "URL de registro exclusiva",
  "전체 동의": "Aceptar todo",
  "전체 발송 대상": "Todos los objetivos de envío",
  "접속 기록 보호": "Protección del registro de acceso",
  "접속을 시작합니다.": "Iniciar acceso.",
  "정보 입력": "Introducir información",
  "조직 전체": "Toda la organización",
  "조직 전체 가입자": "Total de registros de la organización",
  "조회할 에이전트": "Agente a consultar",
  "직속": "Directo",
  "직속 가입자": "Registros directos",
  "직속 에이전트가 전부 수령": "El agente directo recibe todo",
  "처리 시각 / 오류": "Procesado el / Error",
  "최근 30일": "Últimos 30 días",
  "최근 7일": "Últimos 7 días",
  "최근 자산 변환": "Conversiones de activos recientes",
  "최근 포인트 적립": "Acumulaciones de puntos recientes",
  "최상위 에이전트가 전부 수령": "El agente de nivel superior recibe todo",
  "추천 유저 보상 포인트는 각 조직의": "Los puntos de recompensa por usuarios referidos de cada organización se acreditan",
  "추천 코드": "Código de referido",
  "추천 코드 또는 에이전트 라인 코드": "Código de referido o código de línea de agente",
  "추천 코드를 확인할 수 없습니다.": "No se puede verificar el código de referido.",
  "타겟별 인포 버튼 생성 실패": "No se pudo crear el botón de información para el objetivo",
  "테스트 수신 이메일": "Email destinatario de prueba",
  "테스트 수신 이메일을 입력해 주세요.": "Introduzca el email destinatario de prueba.",
  "테이블 그룹 정산 정책": "Política de liquidación del grupo de mesas",
  "테이블 그룹 정산 정책 저장 실패": "No se pudo guardar la política de liquidación del grupo de mesas",
  "특정 에이전트가 전부 수령": "El agente especificado recibe todo",
  "포인트 스탬프": "Sello de puntos",
  "포인트 자산 변환에 실패했습니다.": "No se pudo convertir puntos a activos.",
  "포인트 현황은 조회할 수 있지만 자산 변환은 해당 lv2 에이전트 본인만 실행할 수 있습니다.": "El estado de puntos puede consultarse, pero solo el propio agente lv2 puede convertir puntos a activos.",
  "포인트가 자산으로 변환되었습니다.": "Los puntos se convirtieron a activos.",
  "표시할 닉네임": "Apodo para mostrar",
  "필수 개인정보 수집에 동의하지 않으면 회원가입이 제한됩니다.": "El registro está restringido si no acepta la recopilación obligatoria de información personal.",
  "필수 및 선택 항목에 모두 동의합니다.": "Aceptar todos los elementos obligatorios y opcionales.",
  "필수 약관과 개인정보 안내를 확인합니다.": "Revise los términos obligatorios y el aviso de privacidad.",
  "필수 정보를 입력하고 개인정보 수집 및 이용 안내를 확인한 뒤 가입을 완료해 주세요.": "Introduzca la información obligatoria, revise el aviso de recopilación y uso de información personal y complete el registro.",
  "필수 확인": "Confirmación obligatoria",
  "하단 안내": "Aviso del pie",
  "하부": "Descendencia",
  "하부 가입자": "Registros descendentes",
  "하부 조직 유저": "Usuarios de la organización descendente",
  "하위 에이전트 또는 일반 유저 계정을 생성합니다. 입력한 계정 정보는 생성 즉시 적용됩니다.": "Cree una cuenta de agente subordinado o de usuario normal. La información introducida se aplica inmediatamente después de crearla.",
  "한 줄에 agent_id:percent 입력. percent 합계는 1 또는 100이어야 합니다.": "Introduzca un agent_id:percent por línea. La suma de los porcentajes debe ser 1 o 100.",
  "항목을 누르면 개별 발송 결과를 확인할 수 있습니다.": "Seleccione un elemento para ver los resultados de envíos individuales.",
  "현재 발송 대기": "Actualmente esperando envío",
  "현재 사용할 수 없는 추천 코드입니다.": "Este código de referido no está disponible actualmente.",
  "현재 설정으로 타겟 항목 생성": "Crear elemento de objetivo con la configuración actual",
  "현재 에이전트 아래에 일반 유저를 생성합니다.": "Crear un usuario normal bajo el agente actual.",
  "현재 편집:": "Editando actualmente:",
  "현재 회원가입이 중지되어 있습니다.": "El registro está suspendido actualmente.",
  "활성": "Activo",
  "회원 식별, 계정 관리, 본인 확인 및 계정 복구": "Identificación del miembro, gestión de la cuenta, verificación de identidad y recuperación de la cuenta",
  "회원 식별과 계정 관리·복구를 위해 아이디, 닉네임, 이메일 및 인증 정보를 처리하며, 이용 목적 달성 후 관련 법령에 따라 보관 또는 파기합니다.": "Para la identificación del miembro y la gestión/recuperación de la cuenta, procesamos ID, apodo, email e información de verificación y, una vez cumplida la finalidad, la conservamos o eliminamos conforme a la legislación aplicable.",
  "회원 탈퇴 시까지 또는 관계 법령에서 정한 기간": "Hasta la baja de la cuenta o durante el período exigido por la ley",
  "회원가입": "Registrarse",
  "회원가입 API를 찾지 못했습니다.": "No se encontró la API de registro.",
  "회원가입 링크가 복사되었습니다.": "Se copió el enlace de registro.",
  "회원가입 및 계정 관리를 위해 아래 개인정보를 수집합니다. 내용을 확인한 후 가입을 진행해 주세요.": "Recopilamos la información personal indicada a continuación para el registro y la gestión de la cuenta. Revísela antes de continuar.",
  "회원가입 안내": "Aviso de registro",
  "회원가입 요청을 처리하지 못했습니다.": "No se pudo procesar la solicitud de registro.",
  "회원가입 요청이 거절되었습니다.": "La solicitud de registro fue rechazada.",
  "회원가입이 완료되었습니다. 바로 로그인할 수 있습니다.": "El registro se ha completado. Puede iniciar sesión inmediatamente.",
  "회원가입 요청이 완료되었습니다. 승인된 계정은 바로 로그인할 수 있습니다.": "La solicitud de registro se ha completado. Las cuentas aprobadas pueden iniciar sesión inmediatamente.",
  "회원가입 처리 중…": "Procesando registro…",
  "대상 등록 중": "Registrando destinatarios",
  "발송 대기": "En cola",
  "발송 중": "Enviando",
  "일부 실패": "Parcialmente fallido",
  "테스트 발송": "Envío de prueba",
  "개별 유저": "Usuario individual",
  "수신 동의 전체": "Todos los usuarios con consentimiento",
  "에이전트 수수료 기본값 설정": "Configuración predeterminada de comisiones de agente",
  "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "Configure las tasas de comisión predeterminadas aplicadas a registros por referido y a cuentas subordinadas creadas automáticamente.",
  "현재 계정": "Cuenta actual",
  "현재 수수료": "Comisión actual",
  "설정 상태": "Estado",
  "미설정": "No configurado",
  "설정됨": "Configurado",
  "하위 에이전트 설정 방식": "Modo de configuración de agentes subordinados",
  "자율형과 고정 설정 중 하나를 선택합니다.": "Elija entre configuración autónoma o fija.",
  "자율형": "Autónomo",
  "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "Asigne únicamente la tasa inicial al agente subordinado directo. Ese agente decide las tasas por debajo de él.",
  "고정 설정": "Configuración fija",
  "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "La cuenta actual fija todas las tasas de agentes subordinados y usuarios. Las cuentas subordinadas no verán el popup de configuración.",
  "직속 유저": "Usuario directo",
  "자율형 기본값": "Valores predeterminados autónomos",
  "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "Esta es la tasa inicial aplicada cuando se crea automáticamente un agente subordinado directo.",
  "lv{from} → lv{to} 기본 수수료": "lv{from} → lv{to} Comisión predeterminada",
  "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "El agente subordinado configurará las tasas por debajo de él.",
  "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4 no tiene un nivel de agente inferior, por lo que solo se configura el valor predeterminado de registro de usuario.",
  "전체 고정 기본값": "Valores predeterminados fijos completos",
  "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "Los valores siguientes se aplican automáticamente según el nivel de la cuenta creada.",
  "lv{level} 고정 수수료": "Comisión fija lv{level}",
  "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "Se aplica a nodos de agente lv{level} creados automáticamente.",
  "유저 고정 레이크백": "Rakeback fijo de usuario",
  "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "Se aplica a todos los nuevos nodos de usuario creados bajo la cadena fija.",
  "고정 하위 경로 합계": "Total de la ruta subordinada fija",
  "유저 회원가입 타입": "Tipo de registro de usuario",
  "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "Se aplica cuando un usuario se registra directamente mediante el código de referido del agente actual.",
  "추천인 가입 유저 기본 수수료": "Comisión predeterminada de usuario registrado por referido",
  "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "Se mantiene automáticamente igual al valor fijo del usuario.",
  "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "Se aplica cuando un usuario se conecta directamente bajo lv{level}.",
  "적용 방식": "Modo de aplicación",
  "직접 가입 유저": "Usuario de registro directo",
  "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "Los agentes subordinados sujetos a una política fija del superior no ven un popup separado de configuración predeterminada.",
  "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "El agente subordinado puede iniciar sesión y configurar por separado los valores predeterminados del siguiente nivel.",
  "수수료 기본값 저장에 실패했습니다.": "No se pudieron guardar los valores predeterminados de comisión.",
  "나중에 설정": "Configurar más tarde",
  "기본값 저장": "Guardar valores predeterminados",
  "직접 입력": "Entrada manual",
  "수수료 기본값 설정": "Configurar valores predeterminados de comisión",
  "수수료 기본값 수정": "Editar valores predeterminados de comisión",
  "상위 고정 설정 적용 중": "Configuración fija del superior activa",
  "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "Introduzca un importe de al menos 0.01 con hasta dos decimales.",
  "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "No puede transferir más que el rakeback disponible.",
  "레이크백을 일반 자산으로 이동했습니다.": "El rakeback se ha transferido al saldo de activos generales.",
  "레이크백 이동에 실패했습니다.": "No se pudo transferir el rakeback.",
  "자산으로 이동": "Transferir a activos",
  "레이크백 → 일반 자산": "Rakeback → Activos generales",
  "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "El importe transferido se descuenta del rakeback y se añade inmediatamente a los activos generales.",
  "보유 레이크백": "Rakeback disponible",
  "현재 일반 자산": "Activos generales actuales",
  "이동 금액": "Importe de transferencia",
  "전액": "Todo",
  "이동 중...": "Transfiriendo...",
  "소수 둘째 자리까지 입력 가능": "Hasta dos decimales",
  "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "Introduzca un importe entre 0.01 y 1,000,000,000.00 con hasta dos decimales.",
  "유저": "Usuario",
  "디자인 이미지": "Imagen de diseño",
  "디자인": "Diseño",
  "실제 비율 미리보기": "Vista previa de proporción real",
  "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "El importe del elemento de pago debe ser mayor que 0 y tener como máximo dos decimales.",
  "지급이 처리되지 않았습니다.": "El abono no se procesó.",
  "차감이 처리되지 않았습니다.": "El débito no se procesó.",
  "단독 인포버튼": "Botón de información independiente",
  "단독 인포버튼 생성 실패": "No se pudo crear el botón de información independiente",
  "+ 인포버튼 단독 생성": "+ Crear botón de información independiente",
  "인포버튼 단독 생성": "Crear botón de información independiente",
  "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "¿Restablecer el diseño actual y los textos multilingües a los valores predeterminados?",
  "이미지 파일만 업로드할 수 있습니다.": "Solo se pueden subir archivos de imagen.",
  "배경 이미지 업로드에 실패했습니다.": "No se pudo subir la imagen de fondo.",
  "요소 이미지 업로드에 실패했습니다.": "No se pudo subir la imagen del elemento.",
  "이벤트 카드 디자인 · 광고 편집기 방식": "Diseño de tarjeta de evento · Modo editor de anuncios",
  "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "Edite la propia tarjeta de evento usando una imagen de fondo, posicionamiento libre, elementos de imagen y texto etiquetado por idioma.",
  "기존 하이라이트 문구 불러오기": "Cargar texto destacado existente",
  "디자인 초기화": "Restablecer diseño",
  "새 디자인 사용": "Usar nuevo diseño",
  "편집 디바이스": "Dispositivo de edición",
  "렌더링 방식": "Modo de renderizado",
  "배경 + HTML/CSS 요소": "Fondo + elementos HTML/CSS",
  "이미지만 표시": "Solo imagen",
  "배경 이미지 맞춤": "Ajuste de imagen de fondo",
  "COVER · 영역 채우기": "COVER · Rellenar área",
  "CONTAIN · 전체 표시": "CONTAIN · Mostrar imagen completa",
  "FILL · 강제 맞춤": "FILL · Estirar para ajustar",
  "배경 이미지": "Imagen de fondo",
  "업로드 중...": "Subiendo...",
  "로컬 이미지 업로드": "Subir imagen local",
  "배경 제거": "Eliminar fondo",
  "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "Al subir se completa automáticamente /uploads/info-backgrounds/...",
  "요소 이미지 업로드 중...": "Subiendo imagen del elemento...",
  "배경 이미지 미리보기": "Vista previa de imagen de fondo",
  "입력 내용이 미리보기에 자동 반영됨": "Los cambios se reflejan automáticamente en la vista previa.",
  "언어별 문구 적용 완료 · {count}개 언어 감지": "Texto por idioma aplicado · {count} idiomas detectados",
  "텍스트 {number}": "Texto {number}",
  "요소 이미지는 파일당 10MB 이하만 가능해.": "Cada imagen de elemento debe tener 10 MB o menos.",
  "추가 텍스트": "Texto adicional",
  "요소 이미지": "Imagen del elemento",
  "요소": "Elemento",
  "배너 레이아웃·다국어 편집": "Diseño de banner · Editor multilingüe",
  "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "Introduzca el texto multilingüe de cada elemento de texto en un solo campo y añada imágenes decorativas locales por separado del fondo.",
  "클라이언트 언어별 미리보기": "Vista previa por idioma del cliente",
  "미리보기: {language}": "Vista previa: {language}",
  "번역이 없을 때 사용할 언어": "Idioma de reserva cuando falta una traducción",
  "기본: {language}": "Predeterminado: {language}",
  "편집 화면 {value}%": "Vista del editor {value}%",
  "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "Arrastre los elementos sobre el lienzo ampliado. Las coordenadas se guardan como porcentajes del banner para que escalen con la ventana dentro del mismo perfil de dispositivo.",
  "텍스트 요소별 통합 다국어 입력": "Entrada multilingüe unificada por elemento de texto",
  "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "Puede usar saltos de línea, | o comas como separadores. Ejemplo: Korean:지금 바로 | English:Right now | Japanese:今すぐ",
  "언어별 찾아서 적용": "Detectar y aplicar por idioma",
  "한국어:문구 | 영어:Text | 일본어:テキ스트": "Korean:문구 | English:Text | Japanese:テキスト",
  "추가 텍스트 요소": "Elementos de texto adicionales",
  "+ 텍스트 요소 추가": "+ Añadir elemento de texto",
  "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "No hay elementos de texto adicionales. Añada tantos como necesite.",
  "한국어:지금 바로 | 영어:Right now": "Korean:지금 바로 | English:Right now",
  "캔버스에서 이 텍스트 선택": "Seleccionar este texto en el lienzo",
  "가로 중심": "Centro horizontal",
  "세로 중심": "Centro vertical",
  "확대": "Escala",
  "이미지 투명도": "Opacidad de imagen",
  "텍스트 가독성 오버레이": "Superposición de legibilidad del texto",
  "요소 이미지 업로드": "Subir imagen del elemento",
  "+ 로컬 이미지 추가": "+ Añadir imagen local",
  "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "Añada varios logotipos, cartas, fichas, iconos y otras imágenes por separado del fondo y ajuste la posición y el tamaño de cada uno.",
  "이미지 요소": "Elemento de imagen",
  "기본 요소 선택": "Seleccionar elemento base",
  "{element} 위치·크기": "Posición · Tamaño de {element}",
  "너비": "Ancho",
  "높이": "Alto",
  "기준 글자 크기": "Tamaño de fuente base",
  "투명도": "Opacidad",
  "회전": "Rotación",
  "왼쪽": "Izquierda",
  "가운데": "Centro",
  "오른쪽": "Derecha",
  "글자색": "Color del texto",
  "이미지 맞춤": "Ajuste de imagen",
  "전체 표시 · contain": "Mostrar imagen completa · contain",
  "영역 채우기 · cover": "Rellenar área · cover",
  "강제 맞춤 · fill": "Estirar para ajustar · fill",
  "클라이언트에 표시": "Mostrar en el cliente",
  "이 텍스트 요소 삭제": "Eliminar este elemento de texto",
  "이 이미지 요소 삭제": "Eliminar este elemento de imagen",
  "프로필 좌표 복사": "Copiar coordenadas del perfil",
  "{profile}에서 복사": "Copiar desde {profile}",
  "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "El enlace debe comenzar por http://, https:// o / para una ruta interna.",
  "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · Cada fila guardada es un anuncio independiente.",
  "배너 렌더링 방식": "Modo de renderizado del banner",
  "배경 이미지 + 다국어 HTML/CSS 요소": "Imagen de fondo + elementos HTML/CSS multilingües",
  "이미지 전체만 표시": "Mostrar solo la imagen completa",
  "이미지 전체 표시 · contain": "Mostrar imagen completa · contain",
  "https://... 또는 /lounge": "https://... o /lounge",
  "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "Déjelo vacío para no navegar · Se admiten URL externas o rutas internas como /lounge.",
  "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "En modo de imagen completa, la imagen subida se muestra tal cual. La edición de coordenadas y elementos multilingües está disponible en el modo Imagen de fondo + HTML/CSS.",
  "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "Cada fila guardada es un anuncio independiente · Se gestiona por separado por área/dispositivo/país.",
  "배지": "Insignia",
  "보상": "Recompensa",
  "설명": "Descripción",
  "버튼": "Botón",
  "배지 상단": "Parte superior de la insignia",
  "배지 하단": "Parte inferior de la insignia",
  "강조 제목": "Título destacado",
  "보상 문구": "Texto de recompensa"
};

export default es;
